// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Caml_obj from "rescript/lib/es6/caml_obj.js";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as ConfirmType$OrcaPaymentPage from "../Types/ConfirmType.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "../Utilities/RecoilAtoms.bs.js";
import * as PaymentField$OrcaPaymentPage from "./PaymentField.bs.js";

function GiftCardNumberInput(props) {
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = Recoil.useRecoilState(RecoilAtoms$OrcaPaymentPage.userGiftCardNumber);
  var setGiftCardNumber = match$1[1];
  var giftCardNumber = match$1[0];
  var giftCardNumberRef = React.useRef(null);
  var updateGiftCardNumber = function (val) {
    setGiftCardNumber(function (param) {
          return {
                  value: val,
                  isValid: val !== "",
                  errorString: val !== "" ? "" : localeString.giftCardNumberEmptyText
                };
        });
  };
  var changeGiftCardNumber = function (ev) {
    var val = ev.target.value;
    updateGiftCardNumber(val);
  };
  var onBlurGiftCardNumber = function (ev) {
    var val = ev.target.value;
    updateGiftCardNumber(val);
  };
  var submitCallback = React.useCallback((function (ev) {
          var json = Utils$OrcaPaymentPage.safeParse(ev.data);
          var confirm = ConfirmType$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(json));
          if (confirm.doSubmit && giftCardNumber.value === "") {
            return setGiftCardNumber(function (prev) {
                        var newrecord = Caml_obj.obj_dup(prev);
                        newrecord.errorString = localeString.giftCardNumberEmptyText;
                        return newrecord;
                      });
          }
          
        }), [giftCardNumber.value]);
  Utils$OrcaPaymentPage.useSubmitPaymentData(submitCallback);
  return React.createElement(PaymentField$OrcaPaymentPage.make, {
              setValue: setGiftCardNumber,
              value: giftCardNumber,
              onChange: changeGiftCardNumber,
              onBlur: onBlurGiftCardNumber,
              fieldName: localeString.giftCardNumberLabel,
              name: "giftCardNumber",
              type_: "text",
              paymentType: "Payment",
              maxLength: 32,
              placeholder: localeString.giftCardNumberPlaceholder,
              inputRef: giftCardNumberRef
            });
}

var make = GiftCardNumberInput;

export {
  make ,
}
/* react Not a pure module */
